<script>
export default {
  name: 'malzemeOnayList',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isSelected: {},
  },
  methods: {
    rejectRecord(id) {	
      this.$emit('rejectRecord', id);	
    },	
    approveRecord(id) {	
      this.$emit('approveRecord', id);	
    },
    openDetailDialog(item) {
      this.$emit('details', item);
    },
    changeSelectStatus() {
      this.$emit('select', !this.isSelected);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <v-checkbox @change="changeSelectStatus" :value="isSelected" />
    </td>
    <td><b>{{ item.proje }}</b><br/> {{item.aciklama}}</td>
    <td> {{ item.malzeme }} </td>
    <td> {{ item.miktar }} </td>
    <td> {{ item.birim }} </td>
    <td> {{ item.tur }}</td>
    <td> {{ item.siparisNo }}</td>
    <td> {{ item.tutar|toCurrency}} {{item.doviz}}</td>
    
  </tr>
</template>
